module.exports = __webpack_public_path__ + "images/CC_Text_Entry_Quiz_Placeholder.png";